export default __webpack_public_path__ + "static/media/cloudy-night.c0af96c4.jpg";